import { useRef, useState } from "react";
import { Command } from "lucide-react";

export default function ChatInput() {
  const [value, setValue] = useState("");
  const [deepResearch, setDeepResearch] = useState(true);
  const textareaRef = useRef<HTMLTextAreaElement>(null);

  const handleInput = (e: React.ChangeEvent<HTMLTextAreaElement>) => {
    setValue(e.target.value);
    const el = textareaRef.current;
    if (el) {
      el.style.height = "auto";
      el.style.height = `${Math.min(el.scrollHeight, 220)}px`;
    }
  };

  const handleSubmit = () => {
    if (!value.trim()) return;
    setValue("");
    if (textareaRef.current) textareaRef.current.style.height = "auto";
  };

  const handleKeyDown = (e: React.KeyboardEvent) => {
    if (e.key === "Enter" && !e.shiftKey) {
      e.preventDefault();
      handleSubmit();
    }
  };

  return (
    <div className="w-full max-w-3xl">
      <div className="overflow-hidden rounded-3xl border border-border bg-card shadow-sm transition-shadow focus-within:shadow-md">
        <textarea
          ref={textareaRef}
          value={value}
          onChange={handleInput}
          onKeyDown={handleKeyDown}
          placeholder="Ask anything about your research..."
          className="min-h-[96px] w-full resize-none bg-transparent px-5 pt-5 text-sm leading-6 text-foreground outline-none placeholder:text-muted-foreground"
          rows={3}
        />

        <div className="flex items-center justify-between gap-3 px-4 py-3">
          <div className="flex items-center gap-2">
            <button className="inline-flex h-9 w-9 items-center justify-center rounded-full text-muted-foreground transition-colors hover:bg-accent hover:text-accent-foreground">
              <i className="ri-attachment-2 text-base" />
            </button>

            <button
              type="button"
              className="inline-flex h-9 w-9 items-center justify-center rounded-full text-muted-foreground transition-colors hover:bg-accent hover:text-accent-foreground"
              aria-label="Command"
            >
              <Command className="h-4 w-4" strokeWidth={1.75} />
            </button>

            <button
              onClick={() => setDeepResearch(!deepResearch)}
              className={`inline-flex items-center gap-2 rounded-full border px-3 py-2 text-xs font-medium transition-colors ${
                deepResearch
                  ? "border-primary/20 bg-primary/10 text-primary"
                  : "border-border bg-background text-muted-foreground hover:bg-accent hover:text-accent-foreground"
              }`}
            >
              <i className="ri-flashlight-line text-sm" />
              Deep research
            </button>
          </div>

          <button
            onClick={handleSubmit}
            disabled={!value.trim()}
            className={`inline-flex h-10 w-10 items-center justify-center rounded-full transition-colors ${
              value.trim()
                ? "bg-foreground text-background hover:opacity-90"
                : "cursor-not-allowed bg-muted text-muted-foreground"
            }`}
          >
            <i className="ri-arrow-up-line text-base" />
          </button>
        </div>
      </div>
    </div>
  );
}
